export const company = {
  name: "CV. Pentagon Konstruksindo",
  tagline: "Dari Desain ke Realita, Kami Hadir untuk Anda!",
  brandLine: "Pentagon General Contractor",
  description:
    "Perusahaan jasa arsitektur dan konstruksi yang memberikan layanan terpadu mulai dari desain, perencanaan teknis, hingga pelaksanaan pembangunan untuk hunian, usaha, dan perkantoran.",

  email: "cvpentagonkonstruksindo@gmail.com",

  phones: [
    { label: "WhatsApp", display: "0851-9009-2266", number: "+62851-9009-2266" },
  ],

  address: {
    line1: "Jl. Simpang Ranugrati Selatan 3B No. 22",
    line2: "Kel. Sawojajar, Kec. Kedungkandang",
    line3: "Kota Malang, Jawa Timur 65139"
  },

  mapEmbedUrl:
    "https://www.google.com/maps?q=Jl.%20Simpang%20Ranugrati%20Selatan%203B%20No.%2022%2C%20Sawojajar%2C%20Kedungkandang%2C%20Kota%20Malang%2C%20Jawa%20Timur%2065139&output=embed",

  primaryWhatsapp: "+62851-9009-2266",

  businessHours: [
    { days: "Senin – Sabtu", hours: "08.00 – 17.00" },
    { days: "Minggu", hours: "By appointment" }
  ],

  aboutParagraphs: [
    "CV. Pentagon Konstruksindo adalah perusahaan jasa arsitektur dan konstruksi berbadan hukum yang bergerak profesional dalam perencanaan dan pembangunan bangunan hunian, usaha, dan perkantoran.",
    "Dengan pendekatan kerja yang sistematis dan berorientasi pada hasil, kami menghadirkan layanan konstruksi terpadu mulai dari desain arsitektur, perencanaan teknis, hingga pelaksanaan pembangunan di lapangan.",
    "Didukung tenaga ahli berpengalaman dan komitmen terhadap standar mutu tinggi, kami menjadikan setiap proyek sebagai refleksi profesionalisme, efisiensi, dan integritas."
  ],

  vision:
    "Menjadi perusahaan arsitektur dan konstruksi terpercaya yang memberikan solusi terbaik dan berkelanjutan dalam pembangunan hunian, ruang usaha, dan perkantoran di Indonesia.",

  missions: [
    "Memberikan layanan konstruksi terpadu yang mencakup perencanaan, desain, dan pelaksanaan dengan standar mutu tinggi.",
    "Menghadirkan solusi ruang yang fungsional, estetis, dan bernilai investasi, sesuai kebutuhan dan karakteristik setiap klien.",
    "Menjaga integritas dan profesionalisme dalam setiap tahapan pekerjaan, dari konsultasi awal hingga serah terima proyek.",
    "Mengembangkan sumber daya manusia yang kompeten, adaptif, dan inovatif dalam menjawab tantangan industri konstruksi modern.",
    "Membangun kemitraan jangka panjang dengan klien, melalui pelayanan yang responsif, efisien, dan berorientasi pada kepuasan."
  ],

  legality: {
    nib: "2022400589881",
    sertifikatStandar: "20022400589810001",
    kbli: "41011 - Konstruksi Gedung Hunian",
    npwp: "03.668.119.5-623.000",
    issuedAt: "20 Februari 2024"
  }
};

export const services = [
  {
    id: "design-planning",
    title: "Desain & Perencanaan",
    desc:
      "Mulai dari konsep, visualisasi 3D, gambar kerja, hingga perencanaan teknis untuk memastikan desain bisa dieksekusi dengan akurat.",
    bullets: [
      "Konsep & layout ruang",
      "Gambar kerja (arsitektur/teknis)",
      "Estimasi biaya (RAB) & jadwal kerja",
      "Koordinasi revisi & konsultasi"
    ]
  },
  {
    id: "construction",
    title: "Konstruksi & Pelaksanaan",
    desc:
      "Eksekusi pembangunan dengan kontrol mutu, koordinasi lapangan, dan pelaporan progress yang rapi untuk hasil yang kokoh dan presisi.",
    bullets: [
      "Pekerjaan struktur & arsitektur",
      "Manajemen proyek & pengawasan",
      "Kontrol mutu & keselamatan kerja",
      "Serah terima & dokumentasi"
    ]
  },
  {
    id: "renovation",
    title: "Renovasi & Upgrade Bangunan",
    desc:
      "Renovasi bertahap atau total untuk meningkatkan fungsi, estetika, dan nilai investasi dengan perencanaan yang minim gangguan.",
    bullets: [
      "Renovasi hunian & komersial",
      "Perbaikan, finishing, dan re-layout",
      "Optimasi ruang & utilitas",
      "Estimasi biaya & timeline jelas"
    ]
  },
  {
    id: "interior",
    title: "Interior & Finishing",
    desc:
      "Detail finishing yang rapi dan pemilihan material yang tepat untuk menciptakan ruang nyaman, modern, dan siap digunakan.",
    bullets: [
      "Konsep interior & material",
      "Pekerjaan plafon, lantai, dinding",
      "Furniture built-in (opsional)",
      "QC finishing"
    ]
  }
];

export const processSteps = [
  {
    title: "Konsultasi",
    desc: "Diskusi kebutuhan, target, dan referensi desain."
  },
  {
    title: "Survey & Analisa",
    desc: "Cek lokasi, ukur, dan identifikasi kebutuhan teknis."
  },
  {
    title: "Desain & RAB",
    desc: "Penyusunan konsep, gambar, estimasi biaya, dan timeline."
  },
  {
    title: "Kontrak & Jadwal",
    desc: "Kesepakatan scope, timeline, dan rencana kerja."
  },
  {
    title: "Pelaksanaan",
    desc: "Eksekusi proyek dengan kontrol mutu & progress update."
  },
  {
    title: "Serah Terima",
    desc: "Final check, perapihan, dan dokumentasi pekerjaan."
  }
];

export const faq = [
  {
    q: "Apakah bisa mulai dari desain dulu?",
    a: "Bisa. Kami bisa bantu mulai dari desain & perencanaan, lalu dilanjutkan ke pelaksanaan (design & build) jika diperlukan."
  },
  {
    q: "Apakah melayani renovasi skala kecil?",
    a: "Melayani. Silakan kirim lokasi dan kebutuhan agar kami bisa berikan estimasi awal."
  },
  {
    q: "Bagaimana cara konsultasi cepat?",
    a: "Klik tombol WhatsApp dan kirim detail singkat: lokasi, jenis bangunan, perkiraan luas, dan target waktu."
  }
];
